export const handleToggleTracking = async (
  task,
  setTaskTrackingState,
  updateRecordingTaskInFirestore
) => {
  const newTrackingState = !task.taskBeingTracked;
  if (newTrackingState) {
    updateRecordingTaskInFirestore(task.id);
  }
  try {
    await setTaskTrackingState(task.id, task.projectId, newTrackingState);
  } catch (error) {
    console.error("Error toggling tracking state:", error);
  }
};
